import { ELSIcon } from 'components/common/els';

const RoundCheckmarkIcon = (props: {msg: string}) => (
  <span 
    tabIndex={0}
    role="img"
    className="round-checkmark-icon-wrapper"
    aria-label={props.msg}
    style={{ display: 'inline-block' }}
  >
    <ELSIcon 
      name="checkmark" 
      size="1x" 
      align="sub" 
      color="white" 
      customClass="round-icon round-icon--pass" 
      ariaProps={{ 'aria-hidden': 'true' }}
    />
  </span>
);

RoundCheckmarkIcon.displayName = 'RoundCheckmarkIcon';
export default RoundCheckmarkIcon;
